import styled from "styled-components";
import Link from "next/link";
import MagicText from "@shared/atoms/MagicText";
import BrandButton from "@shared/atoms/BrandButton";

export const CreateAccountForm_div = styled.div`
  background-color: ${(props) => props.theme.colors.grayscale.white};
  border-radius: 12px;
  padding: 16px;
  text-align: center;

  @media ${(props) => props.theme.device.laptop} {
    padding: 32px;
  }
`;

export const MagicText_h1 = styled(MagicText)`
  margin-bottom: 8px;
`;

export const MagicText_p = styled(MagicText)`
  margin-bottom: 40px;
  color: ${(props) => props.theme.colors.grayscale.steel};
`;

export const MagicText_h5 = styled(MagicText)`
  margin-top: 16px;
  margin-bottom: -8px;
  text-align: left;
`;

export const Link_a = styled(Link)`
  text-decoration: none;
  color: ${(props) => props.theme.colors.brand.primary};
  transition: color 0.3s;

  &:hover {
    color: ${(props) => props.theme.colors.brand.secondary};
  }
`;

export const Link_span = styled.span`
  cursor: pointer;
  color: ${(props) => props.theme.colors.brand.primary};
  transition: color 0.3s;

  &:hover {
    color: ${(props) => props.theme.colors.brand.secondary};
  }
`;

export const Form_form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 16px;
`;

export const Input_input = styled.input`
  border: 1px solid ${(props) => props.theme.colors.grayscale.dust};
  border-radius: 32px;
  height: 48px;
  padding: 3px 24px 0 24px;
  outline: none;
  font-size: 16px;

  ::placeholder {
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    color: ${(props) => props.theme.colors.grayscale.smoke};
  }
`;

export const DateContainer_div = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: calc(100% + 16px);
  position: relative;
  left: -8px;
`;

export const DateDropdownWrapper_div = styled.div`
  width: 100%;
  padding: 0 8px;
  margin-bottom: 16px;
  &:nth-child(1) {
    z-index: 3;
  }
  &:nth-child(2) {
    z-index: 2;
  }
  &:nth-child(3) {
    z-index: 1;
    margin-bottom: 0;
  }
  @media ${(props) => props.theme.device.mobileXL} {
    width: calc(100% / 3);
  }
`;

export const PasswordInput_input = styled.input`
  border-style: none;
  height: 48px;
  flex: 1;
  outline: none;
  font-size: 16px;
  width: 100%;

  ::placeholder {
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    color: ${(props) => props.theme.colors.grayscale.smoke};
  }
`;

export const PasswordFieldsContainer_div = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid ${(props) => props.theme.colors.grayscale.dust};
  border-radius: 32px;
  padding: 0 24px;
`;

export const PasswordIcon_span = styled.span`
  float: right;
  height: 24px;
  width: 24px;
`;

export const Error_span = styled.span`
  color: ${(props) => props.theme.colors.action.strawberry};
`;

export const CheckboxContainer_div = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 10px 0;
`;

export const CheckboxInput_input = styled.input`
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  width: 24px;
  height: 24px;
  cursor: pointer;
  background-color: ${(props) => props.theme.colors.grayscale.white};
  border: 1px solid ${(props) => props.theme.colors.grayscale.dust};
  border-radius: 8px;
  flex-shrink: 0;

  :checked {
    background-color: ${(props) => props.theme.colors.brand.primary};
    background-image: ${(props) => props.svg};
  }
`;

export const CheckboxLabel_label = styled.label`
  text-align: left;
`;

export const BrandButton_input = styled(BrandButton)`
  height: 48px;
`;
